// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__vlBeR","title":"Images45_title__3bcnf","images":"Images45_images__3T7MT"};